/**
 * Placeholder shown in place of the TrueBlue header trigger while auth
 * status is settling (`"authenticating"` / `"signingOut"`). Mirrors the
 * shape of the `Authenticated` trigger button (avatar + points label) so
 * the header doesn't shift once the real state resolves.
 */
export const AuthLoadingSkeleton = () => (
  <div
    aria-hidden
    className="
      relative mt-1 flex h-full shrink-0 grow-0 items-center justify-center
      gap-2
    "
    data-fs-element="main-nav-menu-button-user-loading"
  >
    <div
      className="
        size-8 animate-pulse rounded-full
        bg-background-surface-container-variant-medium
      "
    />

    <span
      className="
        hidden h-4 w-16 animate-pulse rounded-sm
        bg-background-surface-container-variant-medium

        lg:inline-block
      "
    />
  </div>
);

AuthLoadingSkeleton.displayName = "Header.TrueBlue.AuthLoadingSkeleton";
